// extracted by mini-css-extract-plugin
var _1 = "linkPointLabel-Xy_j";
export { _1 as "linkPointLabel" }
